import axios from 'axios'
import store from '@/store'

const comicsApi = axios.create({
  baseURL: '',
  headers: { Accept: 'application/json' },
})

comicsApi.interceptors.request.use(
  (config) => {
    const token = store.state.auth.accessToken
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type']
    }
    return config
  },
  (error) => Promise.reject(error),
)

comicsApi.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config
    if (error.response?.status === 401 && originalRequest && !originalRequest._retry) {
      originalRequest._retry = true
      try {
        await store.dispatch('auth/refreshToken')
        return comicsApi(originalRequest)
      } catch (refreshError) {
        store.dispatch('auth/logout')
        return Promise.reject(refreshError)
      }
    }
    return Promise.reject(error)
  },
)

export default {
  getAllPost() {
    return comicsApi.get('/api/comics/post')
  },
  getPostByID(id) {
    return comicsApi.get(`/api/comics/post/${id}`)
  },
  getBySerieId(serieId) {
    return comicsApi.get(`/api/comics/serie/${serieId}`)
  },
  addPost(formData) {
    return comicsApi.post('/api/comics/post/', formData)
  },
  updatePost(id, formData) {
    return comicsApi.patch(`/api/comics/post/${id}`, formData)
  },
  deletePost(id) {
    return comicsApi.delete(`/api/comics/post/${id}`)
  },
  toggleFavorite(id) {
    return comicsApi.patch(`/api/comics/post/${id}/favorite`)
  },
  moveToCollection(id) {
    return comicsApi.patch(`/api/comics/post/${id}/collection`)
  },
  search(search) {
    return comicsApi.get('/api/comics/search', { params: { search } })
  },
  searchGoogleBooks(q, { langRestrict, maxResults } = {}) {
    const params = { q, max_results: maxResults ?? 20 }
    if (langRestrict) params.lang_restrict = langRestrict
    return comicsApi.get('/api/comics/google-books/volumes', { params })
  },
}
